import axios from "axios";

const apiRelatorio = axios.create({
  baseURL: process.env.REACT_APP_URL_RELATORIO,
});

apiRelatorio.defaults.validateStatus = () => true;

export default apiRelatorio;
